import { subDays, subMonths } from 'date-fns';
import { faSpinner } from '@fortawesome/pro-regular-svg-icons/faSpinner';
import { faFileSearch } from '@fortawesome/pro-regular-svg-icons/faFileSearch';
import { faTimes } from '@fortawesome/pro-regular-svg-icons/faTimes';
import { faCheck } from '@fortawesome/pro-regular-svg-icons/faCheck';
import { conversionFuncs } from '@hooks/useFilters';

export const EXCEL_VALUE = 'xls';

export const currencyPriority = {
    USD: 1,
    RUB: 2,
    EUR: 3,
    GBP: 4,
    TON: 5,
};

export const DEFAULT_FILTERS = {
    offerIds: null,
    offerId: null,
    creativeId: null,
    currency: 'USD',
    tsFrom: subDays(new Date(), 6),
    tsTo: new Date(),
    clickId: '',
    subId: null,
    type: '',
};

export const filtersConversionFuncs = {
    offerId: conversionFuncs.number,
    creativeId: conversionFuncs.number,
    currency: conversionFuncs.string,
    tsFrom: conversionFuncs.date,
    tsTo: conversionFuncs.date,
    clickId: conversionFuncs.string,
    subId: conversionFuncs.number,
};

export const rightPositionCurrencySigns = ['RUB', 'TON'];

// TODO: сделать глобальный хук? Много где используется
export const currenciesSigns = {
    USD: '$',
    RUB: '₽',
    EUR: '€',
    GBP: '£',
    TON: 'TON',
};

export const datePeriods = {
    today: {
        tsFrom: new Date(),
        tsTo: new Date(),
    },
    yesterday: {
        tsFrom: subDays(new Date(), 1),
        tsTo: new Date(),
    },
    week: {
        tsFrom: subDays(new Date(), 6),
        tsTo: new Date(),
    },
    month: {
        tsFrom: subMonths(new Date(), 1),
        tsTo: new Date(),
    },
    halfYear: {
        tsFrom: subMonths(new Date(), 6),
        tsTo: new Date(),
    },
};

export const cardsObj = {
    waiting: {
        icon: faSpinner,
        label: 'Waiting',
        symbolPosition: 'after',
        iconColor: 'yellow',
    },
    pending: {
        icon: faFileSearch,
        label: 'Pending',
        iconColor: 'blue',
    },
    rejected: {
        icon: faTimes,
        label: 'Rejected',
        iconColor: 'red',
    },
    completed: {
        icon: faCheck,
        label: 'Completed',
        iconColor: 'green',
    },
};

export const defaultCurrencies = [
    {
        label: 'USD',
        value: 'USD',
    },
    {
        label: 'RUB',
        value: 'RUB',
    },
];

export const dateRanges = [
    {
        key: 'Today',
        value: 'today',
        id: 'today',
    },
    {
        key: 'Yesterday',
        value: 'yesterday',
        id: 'yesterday',
    },
    {
        key: 'Week',
        value: 'week',
        id: 'week',
    },
    {
        key: 'Month',
        value: 'month',
        id: 'month',
    },
    {
        key: 'Half-year',
        value: 'halfYear',
        id: 'halfYear',
    },
];

export const tableColumns = [
    {
        key: 'Date',
        sortable: true,
        value: 'stats_ts',
    },
    {
        key: 'Order number',
    },
    {
        key: 'Status',
    },
    {
        key: 'Creative',
    },
    {
        key: 'Creative type',
        tooltip: 'Only for links to AliExpress RU created from December',
    },
    {
        key: 'SUB',
    },
    {
        key: 'Turnover',
        sortable: true,
        value: 'revenue',
    },
    {
        key: 'Revenue',
        sortable: true,
        value: 'commission_user',
    },
    {
        key: 'Product',
    },
    {
        key: 'Click ID',
    },
];

export const PER_PAGE = 20;

export const FIRST_PAGE = 1;
